<template>
  <div class="page-wrapper">
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 align-self-center">
          <h4 class="text-themecolor">Task Detail</h4>
        </div>
        <div class="col-md-7 align-self-center text-right">
          <div class="d-flex justify-content-end align-items-center">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="javascript:void(0)">Home</a>
              </li>
              <li class="breadcrumb-item active">Task Detail</li>
            </ol>
          </div>
        </div>
      </div>
      <div class="row justify-content-start" style="margin-bottom: 10px">
        <!-- <div class="col-sm-3" style="margin-top: -18px !important">
          <label class="boldText" style="margin-bottom: 0px !important"
            >Tasks</label
          >
          <MultiSelect
            class="AuditMultiSelect"
            v-model="SelectedTasks"
            :options="Tasks"
            optionLabel="taskName"
            placeholder="Search By Tasks"
            display="chip"
            @change="getTableData()"
          />
        </div> -->
        <div class="col-sm-3" style="margin-top: -18px !important">
          <label class="boldText" style="margin-bottom: 0px !important"
            >Status</label
          >
          <MultiSelect
            class="AuditMultiSelect"
            display="chip"
            v-model="SelectedTasksStatus"
            :options="TasksStatus"
            optionLabel="name"
            optionGroupLabel="labelName"
            optionGroupChildren="tasksStatuses"
            placeholder="Search By Task Status"
            @change="getTableData()"
          />
        </div>
        <div class="col-sm-3" style="margin-top: -18px !important">
          <label class="boldText" style="margin-bottom: 0px !important"
            >Assigned User</label
          >
          <MultiSelect
            class="AuditMultiSelect"
            v-model="SelectedUsers"
            :options="Users"
            optionLabel="name"
            optionGroupLabel="label"
            optionGroupChildren="userTaskListsActive"
            placeholder="Search By Users"
            display="chip"
            @change="getTableData()"
          />
        </div>
        <div class="col-sm-3" style="margin-top: -18px !important">
          <label class="boldText" style="margin-bottom: 0px !important"
            >Due Date</label
          >
          <br />
          <input
            style="width: 95%; height: 64%"
            type="text"
            name="daterangePR"
            :value="initDatePR"
            @change="datePickerPR"
            @focus="datePickerPR"
          />
        </div>
      </div>

      <div class="card p-3" ref="tableLoad">
        <div class="table-responsive">
          <div
            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
          >
            <div class="dataTables_length">
              <span style="margin-right: 10px"
                ><label for="">Show </label>
              </span>
              <select
                v-model="pageSize"
                class="form-control form-control-sm"
                aria-label="Default select example"
                @change="pageChange(1)"
              >
                <option selected>50</option>
                <option value="100">100</option>
                <option value="500">500</option>
              </select>

              <span style="margin-left: 10px">
                <label for=""> Entries </label></span
              >
            </div>
          </div>
          <table
            data-height="300"
            class="table display table-bordered text-center table-striped no-wrap"
            id="example23"
          >
            <thead class="thead-dark">
              <tr>
                <th>
                  Task ID
                  <span
                    ><button class="asc-desc-btn" @click="orderBy(0)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Task Name
                  <span
                    ><button class="asc-desc-btn" @click="orderBy(1)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Visti ID
                  <span
                    ><button class="asc-desc-btn" @click="orderBy(2)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Patient Name<span
                    ><button class="asc-desc-btn" @click="orderBy(3)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>Stage</th>
                <th>Assigned Users</th>
                <th>Due Date</th>
                <th>
                  Date Of Service<span
                    ><button class="asc-desc-btn" @click="orderBy(4)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Status<span
                    ><button class="asc-desc-btn" @click="orderBy(5)">
                      ↑ ↓
                    </button></span
                  >
                </th>
              </tr>
            </thead>
            <tbody v-if="totalPages == 0 && totalRows == 0">
              <td valign="top" colspan="6" class="dataTables_empty">
                No matching records found
              </td>
            </tbody>
            <tbody v-else>
              <tr v-for="(pt, index) in PatientTasks" :key="index">
                <td>{{ pt.tid }}</td>
                <td>{{ pt.taskName }}</td>
                <td>{{ pt.vid }}</td>
                <td>{{ pt.patientName }}</td>
                <td>{{ pt.stageName }}</td>
                <td>
                  {{
                    pt.assignedUserIds === null
                      ? ""
                      : pt.assignedUserIds.join(", ")
                  }}
                </td>
                <td>
                  {{ new Date(pt.dueDate).toLocaleDateString().split("T")[0] }}
                </td>
                <td>{{ pt.dosStr }}</td>
                <td>
                  <span
                    v-if="pt.isCloseTask == false"
                    class="bs-label label-warning badgeBorder"
                  >
                    {{ pt.taskStatusName }}
                  </span>
                  <span
                    v-else-if="pt.isActive == true"
                    class="bs-label label-success badgeBorder"
                  >
                    {{ pt.taskStatusName }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <nav aria-label="Page navigation" style="float: right">
          <span
            style="padding-left: 40px"
            v-if="totalRows < pageSize * pageNumber"
            >showing {{ totalRows }} of {{ totalRows }} records</span
          >
          <span style="padding-left: 40px" v-else
            >showing {{ pageSize * pageNumber }} of
            {{ totalRows }} records</span
          >
          <ul class="pagination" style="float: right">
            <li class="page-item colorActive">
              <span v-if="pageNumber == 1">
                <button
                  disabled
                  class="page-link disabledColor"
                  @click="pageChange('Previous')"
                >
                  Previous
                </button>
              </span>
              <span v-else>
                <button class="page-link" @click="pageChange('Previous')">
                  Previous
                </button>
              </span>
            </li>
            <!--show pagination-->
            <li v-if="showPagesMin > 1">
              <button class="page-link" @click="pageChange(1)">1</button>
            </li>
            <li v-if="showPagesMin > 1">
              <button disabled class="page-link disabledColor">...</button>
            </li>
            <!--show pagination-->
            <li
              v-for="pageNum in totalPages"
              :key="pageNum"
              class="page-item colorActive"
            >
              <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax">
                <span v-if="pageNumber == pageNum"
                  ><button
                    class="page-link activeColor"
                    disabled
                    @click="pageChange(pageNum)"
                  >
                    {{ pageNum }}
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange(pageNum)">
                    {{ pageNum }}
                  </button></span
                >
              </span>
            </li>

            <!--show pagination-->
            <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
              <button disabled class="page-link disabledColor">...</button>
            </li>
            <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
              <button class="page-link" @click="pageChange(totalPages)">
                {{ totalPages }}
              </button>
            </li>
            <!--show pagination-->
            <li class="page-item colorActive">
              <span v-if="pageNumber == totalPages">
                <button
                  disabled
                  class="page-link disabledColor"
                  @click="pageChange('Next')"
                >
                  Next
                </button>
              </span>
              <span v-else>
                <button class="page-link" @click="pageChange('Next')">
                  Next
                </button>
              </span>
            </li>
          </ul>
        </nav>
      </div>
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
  </div>
  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- End Wrapper -->
  <!-- ============================================================== -->
</template>

<script>
// import localMixin from "./Mixins/DailyReport";
import axios from "axios";
import moment from "moment";
// import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "TaskDetail",
  components: {
    // Multiselect,
  },

  data() {
    return {
      TimerObject: {},
      pageSize: 50,
      pageNumber: 1,
      totalRows: 0,
      totalPages: 10,
      initDatePR: "",
      showPagesMin: 1,
      showPagesMax: 5,
      startDatePR: {},
      endDatePR: {},
      UsersList: [],
      Users: [],
      Tasks: [],
      TasksStatus: [],
      SelectedUsers: [],
      SelectedTasks: [],
      SelectedTasksStatus: [],
      PatientTasks: [],
      sortCol: 0,
      sortOption: true,
    };
  }, // data

  methods: {
    datePickerPR() {
      const self = this;
      $('input[name="daterangePR"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDatePR = start.format("MM/DD/YYYY");
          self.endDatePR = end.format("MM/DD/YYYY");
          self.initDatePR =
            self.dateToMDY(start.format("MM/DD/YYYY")) +
            " - " +
            self.dateToMDY(end.format("MM/DD/YYYY"));
        }
      );
    },
    loadInit() {
      this.intDummyComm();
      this.getTableFilters().finally(() => {
        this.getTableData();
      });
    },
    async getTableFilters() {
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetTaskDetailsAll",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data.data;
          this.TasksStatus = myData.taskStatusGroup;
          this.Tasks = myData.allTasks;
          this.Users = myData.usersGroups;

          const usersList = myData.usersGroups.reduce((acc, curr) => {
            return [...acc, ...curr.userTaskListsActive];
          }, []);

          this.UsersList = usersList;
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      //show pagination
      if (this.showPagesMax / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
      } else if (this.showPagesMin / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
        if (this.showPagesMax < 5) {
          this.showPagesMax = 5;
        }
      } else {
        this.showPagesMin = 1;
        this.showPagesMax = 5;
      }
      //show pagination
      this.loadInit();
    },
    async getTableDataA() {
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.pageNumber = this.pageNumber;

      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetAllCheckinPatientTasks",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.PatientTasks = myData.data;
            this.totalRows = this.PatientTasks[0].total;
            this.totalPages = this.PatientTasks[0].totalPages;
          } else {
            this.error;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },
    async getTableData() {
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.pageNumber = this.pageNumber;
      const userIds = this.SelectedUsers.map(function (x) {
        return x.userId;
      });
      const taskIds = this.SelectedTasks.map(function (x) {
        return x.taskID;
      });
      const statusIds = this.SelectedTasksStatus.map(function (x) {
        return x.id;
      });
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      const obj = {
        userIds: userIds,
        taskIds: taskIds,
        statusIds: statusIds,
        DC: this.dummyComm,
        startDate: this.startDatePR,
        endDate: this.endDatePR,
        sortCol: this.sortCol,
        sortOption: this.sortOption,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetAllCheckinPatientTasks",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.PatientTasks = myData.data;
            this.PatientTasks.forEach((x) => {
              var nameList = [];
              if (x.assignedUserIds !== null) {
                x.assignedUserIds.split(",").forEach((y) => {
                  nameList.push(
                    this.UsersList.find((z) => z.userId == parseInt(y)).name
                  );
                });

                x.assignedUserIds = nameList;
              }
            });

            this.totalRows = this.PatientTasks[0].total;
            this.totalPages = this.PatientTasks[0].totalPages;
            if (this.pageNumber > this.totalPages) this.pageNumber = 1;
          } else {
            this.PatientTasks = [];
            this.totalRows = 0;
            this.totalPages = 0;
            this.pageNumber = 1;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },
    orderBy(sortCol) {
      if (sortCol == this.sortCol) {
        if (this.sortOption == false) {
          this.sortOption = true;
        } else {
          this.sortOption = false;
        }
      } else {
        this.sortOption = true;
      }
      this.sortCol = sortCol;
      this.getTableData();
    },
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
  }, // methods

  computed: {}, // computed

  watch: {
    initDatePR: function () {
      this.loadInit();
    },
  }, //watch

  mounted() {
    this.StartLogoutTime();

    var date = new Date();

    this.startDatePR = date;
    this.endDatePR = date;
    this.initDatePR = this.dateToMDY(date) + " - " + this.dateToMDY(date);
    // this.loadInit();
  }, // mounted
};
</script>

<style scoped>
.AuditMultiSelect {
  width: 100%;
}
#font1 {
  font-weight: bold;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
.colorActive {
  color: #f95c2e;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
</style>